import { useState, useRef } from "react";
import { useClickOutside } from "../utils/useClickOutside";
import Modal from "./modal.component";
import { VscQuestion } from "react-icons/vsc";

const Instruction = () => {
  const [open, setOpen] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, () => setOpen(false));

  const handleMarkClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setOpen(() => !open);
  };

  return (
    <div ref={ref}>
      <div className="flex content-center items-center hover:bg-opacity-50 duration-200 text-slate-300 hover:text-white font-light">
        <button onClick={handleMarkClick}>
          <VscQuestion />
        </button>
      </div>
      <Modal setOpen={setOpen} open={open} id="modal-instruction">
        <p className="w-full border-b text-center text-lg md:text-2xl">
          How to play
        </p>
        <br />
        <p>finish writing this oscar</p>
      </Modal>
    </div>
  );
};

export default Instruction;
